/**
 * Settings Keys
 */ export class SettingsConstants {
}
SettingsConstants.Config = "config";
SettingsConstants.SessionMetaData = "sessionmetadata";
